import axios, { AxiosResponse } from "axios";

export const uploadFile = async (file: FormData): Promise<AxiosResponse> => {
    const response = await axios.post(`sharePoint/upload`, file);
    return response;
}